import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// ########## Remotes #############################
// remote queries
export const GET_ESOP_GRANTS = gql`
  query EsopGrants($projectId: ID!) {
    esopGrants(projectId: $projectId) {
      ...EsopGrantFragment
    }
  }
  ${fragments.esopGrant}
`
// remote mutations
export const _ADD_ESOP_GRANT = gql`
  mutation _AddEsopGrant($projectId: ID!, $input: EsopGrantInput!) {
    _addEsopGrant(projectId: $projectId, esopGrantInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_ESOP_GRANT = gql`
  mutation AddEsopGrant($projectId: ID!, $input: EsopGrantInput!) {
    addEsopGrant(projectId: $projectId, esopGrantInput: $input) {
      ...EsopGrantFragment
    }
  }
  ${fragments.esopGrant}
`

export const _SAVE_ESOP_GRANT = gql`
  mutation _SaveEsopGrant($esopGrantId: ID!, $input: EsopGrantInput!) {
    _saveEsopGrant(esopGrantId: $esopGrantId, esopGrantInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_ESOP_GRANT = gql`
  mutation _DeleteEsopGrant($esopGrantId: ID!) {
    _deleteEsopGrant(esopGrantId: $esopGrantId) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _SAVE_MULTIPLE_ESOP_GRANTS = gql`
  mutation _SaveMultipleEsopGrants($projectId: ID!, $esopGrantInputs: [EsopGrantInput!]!) {
    _saveMultipleEsopGrants(projectId: $projectId, esopGrantInputs: $esopGrantInputs) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _UPDATE_MULTIPLE_VESTING_SCHEDULES = gql`
  mutation _UpdateMultipleVestingSchedules(
    $projectId: ID!
    $esopGrantInputs: [EsopGrantInput!]!
    $buyOutInputs: [BuyOutInput!]!
    $equityInvestmentInputs: [InvestmentInput!]!
  ) {
    _updateMultipleVestingSchedules(
      projectId: $projectId
      esopGrantInputs: $esopGrantInputs
      buyOutInputs: $buyOutInputs
      equityInvestmentInputs: $equityInvestmentInputs
    ) {
      ...Project
    }
  }
  ${fragments.project}
`

const esopGrantQueries = {
  getRemote: GET_ESOP_GRANTS,
  addRemote: _ADD_ESOP_GRANT,
  saveRemote: _SAVE_ESOP_GRANT,
  deleteRemote: _DELETE_ESOP_GRANT,
  saveOp: '_saveEsopGrant',
  addOp: '_addEsopGrant',
  deleteOp: '_deleteEsopGrant',
}

export default esopGrantQueries
